import { useEffect, useState } from 'react'

export type UseComponentAttributeObserverProps = {
  element: HTMLElement
  attribute: string
}

const useComponentAttributeObserver = ({
  element,
  attribute
}: UseComponentAttributeObserverProps) => {
  const [hasAttribute, setHasAttribute] = useState<boolean | null>(null)

  useEffect(() => {
    if (!element) return

    const updateState = () => {
      setHasAttribute(element.hasAttribute(attribute))
    }

    updateState()

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === attribute) {
          updateState()
        }
      })
    })

    observer.observe(element, { attributes: true })

    return () => observer.disconnect()
  }, [attribute, element])

  return hasAttribute
}

export default useComponentAttributeObserver
